import i18n from 'services/base/i18n';

export default {
  title:             () => i18n.pgettext('Pages|List History', 'TRAFFIC HISTORY'),
  creditIP2Location: () => i18n.pgettext('Pages|List History', 'This site or product includes IP2Location LITE data available from https://www.ip2location.com.'),
};
